import ConstraintsHandler from './constraints-handler';
import {getSimplexService} from 'services/sports/factory';

export default class ServerConstraintsHandler extends ConstraintsHandler {
    private constraintsFactory;
    constructor(args) {
        super(args);

        this.constraintsFactory = getSimplexService(this.state.sportConfig, {
            store: this.store,
        });

        this.operationData.constraints.base = {
            objective: this.constraintsFactory.exec('max', {}, {}),
            subjectTo: this.constraintsFactory.exec(
                'subjectToPermanent',
                {
                    sportConfig: this.state.sportConfig,
                },
                {},
            ),
        };
    }

    public getConstraints(): any {
        let constraints = cp(this.operationData.constraints.base);

        constraints.randomObjective = this.constraintsFactory.exec('maxRandom', {}, {});
        constraints.subjectTo = {
            ...this.constraintsFactory.exec(
                'subjectToAlterable',
                {
                    sportConfig: this.state.sportConfig,
                },
                {},
            ),
            ...constraints.subjectTo,
        };

        constraints.additionalObjective = {
            row: this.constraintsFactory.exec('additionalObjective', {}),
        };

        this.operationData.constraints.afterCreating = cp(constraints);

        return this.doExecutable('beforeReturningConstraints');
    }
}
